export default "__VITE_ASSET___NIQInld__"